/**
 * Utility function to replace old R2 domain with new domain in image URLs
 * Replaces "r2.whatthefuckareyouwearing.com" with "r2.wtf.style"
 * 
 * @param url - Image URL string
 * @returns URL with domain replaced
 */
export function replaceImageDomain(url: string): string {
	return url.replace(/r2\.whatthefuckareyouwearing\.com/g, 'r2.wtf.style')
}

